const $ = window.jQuery;

let active_cat = 'all-categories';

let new_posts = '';

let load_more = $('.block-latest-articles').find('.load-more');

//Listen load more button
$('.load-more').click(function(){
	load_articles($(this));
});

function load_articles(button) {
	var data = {
		'action': 'loadmore',
		'query': latest_posts, // that's how we get params from wp_localize_script() function
		'page' : latest_current_page,
		'column_class' : latest_column_class,
		'active_cat' : active_cat,
		'post_type' : latest_post_type
	};

	$.ajax({ // you can also use $.post here
		url : ajaxurl, // AJAX handler
		data : data,
		type : 'POST',
		beforeSend : function ( xhr ) {
			button.text(translations.loading); // Käytä translations-objektia
		},
		success : function( data ){
			if( data ) { 
				new_posts = data;
				$('.block-latest-articles').find('.articles-list').html(new_posts);
				button.text(translations.morePosts); // Käytä translations-objektia
				latest_current_page++;

				var query_post_amount = $("#query-post-amount").data('total-query-posts');

				if ( latest_current_page == latest_max_page || latest_current_page == query_post_amount)  {
					button.hide(); // if last page, remove the button
				} else {
					button.show()
				}
				
				// you can also fire the "post-load" event here if you use a plugin that requires it
				// $( document.body ).trigger( 'post-load' );
			} else {
				button.hide(); // if no data, remove the button as well
			}

			//filter_articles(button, active_cat);
		}
	});
}

//Watch category changes
$('.category-buttons button').on('click', function(e) {
	e.preventDefault();
	new_posts = '';
	active_cat = $(this).data('category');
	latest_current_page = 0;
	
	// Lisää active-luokka klikatulle napille ja poista muilta
	$('.category-buttons button').removeClass('active');
	$(this).addClass('active');
	
	load_articles(load_more);
});

// Add subcategory button click handler
$('.subcategory-buttons button').on('click', function(e) {
	e.preventDefault();
	new_posts = '';
	active_cat = $(this).data('category');
	const parentCategory = $(this).data('parent-category');
	latest_current_page = 0;
	
	// Add active class to clicked button and parent button
	$('.subcategory-buttons button, .category-buttons button').removeClass('active');
	$(this).addClass('active');
	$(`.category-buttons button[data-category="${parentCategory}"]`).addClass('active');
	
	// Show this subcategory container
	$('.subcategory-buttons').hide();
	$(`.subcategory-buttons[data-parent="${parentCategory}"]`).show();
	
	load_articles(load_more);
});

//Hide cards with unactive category
function filter_articles(find_parent, active_filter) {
	find_parent.closest('.block-latest-articles').find('.articles-list').children().each(function(e) {
		let cats = $(this).data('cats');
		let parentCats = $(this).data('parent-cats') || [];

		if(active_cat == 'all-categories') {
			$(this).show();
		} else if(cats !== undefined && cats.indexOf(active_cat) !== -1) {
			// Show if the post has this category
			$(this).show();
		} else if(parentCats.indexOf(active_cat) !== -1) {
			// Show if this category is a parent of one of the post's categories
			$(this).show();
		} else {
			// Check if it's a subcategory
			const subCatButton = $(`.subcategory-buttons button[data-category="${active_cat}"]`);
			if(subCatButton.length > 0) {
				const parentCat = subCatButton.data('parent-category');
				// If the post is in any subcategory of the same parent
				if(parentCats.indexOf(parentCat) !== -1) {
					$(this).show();
				} else {
					$(this).hide();
				}
			} else {
				$(this).hide();
			}
		}
	});
}